import React from 'react';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep, totalSteps, stepLabels }) => {
  return (
    <nav className="wizard-progress" aria-label="Print wizard progress">
      {/* display: contents keeps the <li> steps as direct flex items of .wizard-progress */}
      <ol style={{ display: 'contents' }}>
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
          <li
            key={step}
            className={`progress-step ${step <= currentStep ? 'active' : ''}`}
            aria-current={step === currentStep ? 'step' : undefined}
          >
            <div className="step-number">{step}</div>
            <div className="step-label">
              {stepLabels[step - 1]}
            </div>
          </li>
        ))}
      </ol>
      <span className="visually-hidden" aria-live="polite">
        Step {currentStep} of {totalSteps}: {stepLabels[currentStep - 1]}
      </span>
    </nav>
  );
};

export default WizardProgress;
